/** @file Hook: registers the `curves` key table; its context is pushed while the graph canvas has focus. */
import { useEffect, type RefObject } from 'react';
import { registerEffective } from '../../shell/shortcuts/registerEffective';
import { useFocusContext } from '../../ui-kit/useFocusContext';
import { bindings } from './bindings';
import { curveViewStore } from './curveViewStore';

/** Handlers of `bindings.ts`, by binding id. */
const HANDLERS: Record<string, () => void> = {
  'curves.cancelGesture': () => { curveViewStore.setState({ gesture: { kind: 'idle' } }); },
  'curves.frameAll': () => { curveViewStore.setState({ fitted: false }); },
};

/** Keys reach the graph only through @pose2d/shortcuts; focus pushes and pops the context. */
export function useCurveBindings(canvasRef: RefObject<HTMLCanvasElement | null>): void {
  useFocusContext(canvasRef, 'curves');
  useEffect(() => registerEffective('curves', bindings, HANDLERS), []);
}
